import React from 'react';
import { theme } from '../config/theme';

export function auroraBaseBackground(mode) {
  return mode === 'light'
    ? 'linear-gradient(180deg, #f4f7fa 0%, #e2e9f2 100%)'
    : 'linear-gradient(180deg, #0b1220 0%, #0b1220 100%)';
}

/**
 * Aurora — soft gradient background with subtle neural dot pattern overlay.
 * Designed to sit behind content (position absolute/relative wrapper decides).
 */
export default function Aurora({ className = '', style }) {
  // Colors are read from theme tokens via CSS variables to respect light/dark
  const baseBg = auroraBaseBackground(theme.mode);

  const gradient = `${baseBg},
                    radial-gradient(60vmax 40vmax at -10% -15%, ${theme.brand}2a 0%, transparent 55%),
                    radial-gradient(50vmax 35vmax at 110% -10%, ${theme.brandAlt}22 0%, transparent 60%),
                    radial-gradient(40vmax 30vmax at 50% 10%, rgba(255,255,255,.45) 0%, transparent 55%)`;

  const dotPattern = {
    backgroundImage:
      'radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px), radial-gradient(rgba(0,0,0,0.06) 1px, transparent 1px)',
    backgroundSize: '24px 24px, 24px 24px',
    backgroundPosition: '0 0, 12px 12px',
    opacity: theme.mode === 'light' ? 0.25 : 0.18,
  };

  return (
    <div className={className} style={{ ...style }}>
      <div aria-hidden className="absolute inset-0" style={{ background: gradient }} />
      <div aria-hidden className="absolute inset-0" style={dotPattern} />
    </div>
  );
}


